import SiteHeader from './components/SiteHeader';
import HeroSection from './components/HeroSection';
import UpcomingPreview from './components/UpcomingPreview';
import UnconfirmedFeed from './components/UnconfirmedFeed';
import WhisperStream from './components/WhisperStream';
import TopicIndex from './components/TopicIndex';
import TrustStats from './components/TrustStats';
import FaqSection from './components/FaqSection';
import SubscribeNotice from './components/SubscribeNotice';
import ArchiveStrip from './components/ArchiveStrip';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body">
      <SiteHeader />
      <main>
        <HeroSection />
        <UpcomingPreview />
        <UnconfirmedFeed />
        <WhisperStream />
        <TopicIndex />
        <TrustStats />
        <FaqSection />
        <SubscribeNotice />
        <ArchiveStrip />
      </main>
      <SiteFooter />
    </div>
  );
}